module.exports = __webpack_public_path__ + "static/media/bu.d8c8e742.png";